import React from 'react'
import styled from 'styled-components'
import { StoresProps, StoreLabels } from './stores.props'
import { Heading } from '../Common'
import { StoresContextProvider } from './stores.context'
import { StoreList, Store } from './Components'
import { CitySelector } from './Components/CitySelector'
import dynamic from 'next/dynamic'
import {
  LocalLabelsProvider,
  useWindowDimensions,
} from '@sentecacommerce-theme/lib'

const StoresMap = dynamic<any>(
  () => import('./Components/StoresMap').then((mod) => mod.StoresMap),
  {
    ssr: false,
  }
)

export const Stores = ({ title, stores, pinIcon, labels }: StoresProps) => {
  const { width } = useWindowDimensions()

  const renderMap = width >= 768

  return (
    <LocalLabelsProvider<StoreLabels> labels={labels}>
      <StoresContextProvider stores={stores}>
        <Container>
          <HeadingWrapper>
            <Heading data={title} topTitle as="h1" />
          </HeadingWrapper>
          <Flex>
            <ContentWrapper>
              <CitySelectorWrapper>
                <CitySelector />
              </CitySelectorWrapper>
              <StoreListContainer>
                <StoreList
                  renderStore={(store) => <Store store={store} />}
                  pinIcon={pinIcon}
                />
              </StoreListContainer>
            </ContentWrapper>
            <DesktopMapContainer>
              <StickyMap>
                {renderMap && <StoresMap pinIcon={pinIcon} />}
              </StickyMap>
            </DesktopMapContainer>
          </Flex>
        </Container>
      </StoresContextProvider>
    </LocalLabelsProvider>
  )
}

const Container = styled.section.attrs({
  className: 'container',
})``

const Flex = styled.div.attrs({
  className: 'row g-5',
})``

const ContentWrapper = styled.div.attrs({
  className: 'col-12 col-md-6',
})``

const StoreListContainer = styled.div``

const DesktopMapContainer = styled.aside.attrs({
  className: 'd-none d-md-block col-md-6',
})``

const CitySelectorWrapper = styled.div.attrs({
  className: 'mb-5',
})``

const HeadingWrapper = styled.div.attrs({
  className: 'mb-3',
})``

const StickyMap = styled.div`
  position: sticky;
  top: 8rem;
`
